import {
  EditorHandlers,
  PlatformApiMethods,
} from '@wix/editor-platform-host-integration-apis';
import { EditorPointerServiceAPI } from '@wix/editor-platform-feature-store';

import { AppData } from '@wix/document-services-types';

export const getEditorSelectionHandlers = (
  platformApiMethods: PlatformApiMethods,
  editorPointerAPI?: EditorPointerServiceAPI,
): EditorHandlers => ({
  highlightComponent: (pointer) => {
    const compRef = editorPointerAPI?.getDocumentPointer(pointer);
    if (!compRef) {
      return;
    }

    platformApiMethods.editor.selection.locateAndHighlightComponentByCompRef(
      {} as AppData,
      '',
      { compRef },
    );
  },
  removeHighlight: (pointer) => {
    const compRef = editorPointerAPI?.getDocumentPointer(pointer);
    if (!compRef) {
      return;
    }

    platformApiMethods.editor.selection.removeFocusByCompRef?.({
      compRef,
    });
  },
});
